export class PetNoteModel {
    note_sequence: number
    pet_name: string
    pet_no: number
    note_type: number
    note_text: string
    type_desc: string
    note_date: any
    note_time: any
    show_more: boolean
    table: string
    editable: boolean

    soap: string[]
    // subjective: string
    // objective: string
    // assessment: string
    // plans: string
    // progress: string

    constructor(
        note_sequence: number,
        pet_name: string,
        pet_no: number,
        note_type: number,
        note_text: string,
        type_desc: string,
        note_date: any,
        table?: string,
        editable?: boolean
        // subjective: string,
        // objective: string,
        // assessment: string,
        // plans: string,
        // progress: string
    ) {
        this.note_sequence = note_sequence
        this.pet_name = pet_name
        this.pet_no = pet_no
        this.note_type = note_type
        this.note_text = note_text
        this.type_desc = type_desc
        this.note_date = note_date
        this.soap = ['', '', '', '', '']
        this.show_more = false,
        this.table = table
        this.editable = editable
        // this.subjective = subjective
        // this.objective = objective
        // this.assessment = assessment
        // this.plans = plans
        // this.progress = progress
    }
}

export class PetNoteTypeModel {
    note_type: number
    type_desc: string 

    constructor(
        note_type: number,
        type_desc: string, 
    ) {
        this.note_type = note_type
        this.type_desc = type_desc 
    }
}

export class NoteModel {
    note_sequence: number
    pet_no: number
    pet_name: string
    notedate: string
    notetext: string
    notetype_list: number[]
    editable?: boolean

    constructor(
        note_sequence: number,
        pet_no: number,
        pet_name: string,
        notedate: string,
        notetext: string,
        notetype_list: number[],
        editable?: boolean
    ) {
        this.note_sequence = note_sequence
        this.pet_no = pet_no
        this.pet_name = pet_name
        this.notedate = notedate
        this.notetext = notetext
        this.notetype_list = notetype_list
        this.editable = editable
    }
}

export class LabNameModel {
    public test_desc: string;
    public seq_no: number;

    constructor(test_desc: string, seq_no: number) {
        this.test_desc = test_desc;
        this.seq_no = seq_no;
    }
}

export class LoadTestModel {
    public low: any;
    public high: any;
    public test_code: string;
    public test_desc: string;
    public result_length: number;
    public unit: string;
    public seq_no: number;
    public selected?: boolean;

    constructor(
        low: any,
        high: any,
        test_code: string,
        test_desc: string,
        result_length: number,
        unit: string,
        seq_no: number,
        selected?: boolean
    ) {
        this.low = low;
        this.high = high;
        this.test_code = test_code;
        this.test_desc = test_desc;
        this.result_length = result_length;
        this.unit = unit;
        this.seq_no = seq_no;
        this.selected = selected

    }
}